/* eslint-disable complexity */
import chameleon from "@chamaeleonidae/chmln";
import LocalStoreManager from "./local-store-manager";
import getAppCustomEnv from "./get-app-custom-env";
export const initChameleon = async () => {
  try {
    const appCustomEnv = await getAppCustomEnv();

    const token = appCustomEnv.VUE_TOKEN_CHAMELEON;
    console.log('token:' + token)
    if (!token) {
      throw new Error("No VUE_TOKEN_CHAMELEON provided in env.json");
    }
    chameleon.init(token);
    let localStore = new LocalStoreManager();
    chameleon.identify(localStore.getUserId(), {
      name: localStore.getUserFirstName(),
      email: localStore.getUserEmail(),
      company: {
        uid: localStore.getCompanyId(),
      },
    });
  } catch (e) {
    console.warn("Error while initializing Chameleon integration", e);
  }
};
